export default {
  reviewCompleteHeader: 'Zkontrolujte a dokončete',
  participants: 'Účastníci',
  enterParticipantInfoText:
    'Zadejte prosím informace pro každého účastníka této zkušenosti.',
  purchaser: 'Kupující',
  firstName: 'Jméno',
  lastName: 'Příjmení',
  email: 'Email',
  optionalEmail: 'Email: (volitelný)',
  participantFieldPlaceholder:
    'Přidejte nového nebo vyberte stávajícího účastníka',
  reservationSummary: 'Souhrn rezervace',
  editParticipantsDetails: 'Upravit detaily účastníka',
  participantDetails: 'Detaily účastníka',
  duplicatePurchaserText: 'Stejný jako kupující',
  phone: 'Telefon',
  addParticipant: 'Další {{tierLabel}}',
  participant: 'Účastník',
  removeParticipant: 'Odstranit',
  experienceCheckoutCompleted: 'Dokončení pokladny zážitku',
  experienceCartCheckout: 'Pokladna košíku zážitku',
  experienceLimitReached:
    'Litujeme, tato zkušenost dosáhla maximálního počtu účastníků',
  payment: 'Platba',
  duration: 'Trvání',
  discountCode: 'Slevový kód',
  removeCode: 'Odstranit kód',
  invalidCodeValidation: 'Neplatný kupón',
  networkErrorDiscountCode: 'Na naší straně se něco pokazilo',
  onlyOneCouponCodeAllowed: 'Povoleno pouze jeden slevový kód',
  creditCodeHasAlreadyBeenApplied: 'Kreditní kód již byl použit',
  discount: 'Sleva',
  promo: 'Propagační',
  promoCode: 'Propagační kód',
  apply: 'Aplikovat',
  total: 'Celkem',
  subTotal: 'Mezisoučet',
  includes: 'Zahrnuje',
  and: 'a',
  addHostNotes: 'Přidat poznámky pro hostitele',
  brandAggreementText:
    'Souhlasím, nebo jinak potvrzuji, že jsem oprávněn jménem účastníka souhlasit s obchodními podmínkami',
  termsAggreementValidation: 'Prosím, souhlaste s podmínkami',
  firstNameValidation: 'Jméno je vyžadováno',
  lastNameValidation: 'Příjmení je vyžadováno',
  emailValidation: {
    emailRequiredText: 'Email je vyžadován',
    invalidEmail: 'Neplatná emailová adresa',
    not_specified: 'Nesprávná emailová adresa',
  },
  phoneValidation: {
    'Invalid Phone Number': 'Neplatné telefonní číslo',
    not_specified: 'Neplatné',
    phoneRequiredText: 'Telefonní číslo je vyžadováno',
  },
  participantFirstNameValidation: 'Jméno účastníka je vyžadováno',
  participantLastNameValidation: 'Příjmení účastníka je vyžadováno',
  complete: 'Kompletní',
  '404Message': 'Nenalezeno',
  waiting: 'Čekání...',
  complimentary: 'Bezplatný',
  confirmationHeader: 'Vaše zkušenost byla rezervována!',
  confirmationText:
    'Potvrzovací email byl odeslán na {{email}} s dalšími detaily',
  viewAll: 'Zobraz',
  paymentMethod: 'Způsob platby',
  creditCard: 'Kreditní karta',
  roomCharge: 'Poplatek za pokoj',
  memberCharge: 'Poplatek pro členy',
  roomOrReservationNumber: 'Číslo pokoje nebo potvrzovací číslo',
  roomNumber: 'Číslo pokoje',
  roomNumberLegacy: 'Číslo pokoje nebo kód rezervace',
  memberNumber: 'Číslo člena',
  kicc: 'Jednoduchá platba',
  chargeValidation: 'Číslo pokoje a příjmení jsou vyžadovány',
  memberNumberValidation: 'Číslo člena je vyžadováno',
  invalidRoomNumber: 'Číslo pokoje je neplatné',
  invalidRoomNumberLegacy: 'Číslo pokoje nebo kód rezervace je neplatný',
  invalidMemberNumber: 'Číslo člena je neplatné',
  invalidPhoneNumber: 'Telefonní číslo je neplatné',
  requiredPhoneNumber: 'Telefonní číslo je vyžadováno',
  guestNameIsRequired: 'Jméno hosta je vyžadováno',
  roomNumberIsRequired: 'Číslo pokoje je vyžadováno',
  roomNumberIsRequiredLegacy: 'Číslo pokoje nebo kód rezervace je vyžadován',
  roomOrReservationNumberIsRequired:
    'Číslo pokoje nebo potvrzovací číslo je vyžadováno',
  cardNumberIncomplete: 'Číslo karty je neúplné',
  lastNameValidationError: 'Příjmení je vyžadováno',
  isReqd: 'je vyžadováno',
  reservationCode: 'Rezervační/potvrzovací číslo',
  nonHotelGuest: 'Host mimo hotel',
  onPropertyGuest: 'Host na majetku',
  preArrivalGuest: 'Host před příjezdem',
  cardNumber: 'Číslo karty',
  pmsValidationErrorMessage:
    'Neplatné příjmení nebo číslo pokoje nebo potvrzovací číslo',
  pmsDateValidationErrorMessage:
    'Litujeme! Datum zážitku není v rozmezí vašeho příjezdu a odjezdu.',
  fullName: 'Celé jméno',
  checkout: 'Odhlášení',
  editParticipants: 'Upravit účastníky',
  private: 'Soukromý',
  browseAllExperieces: 'Prohlédnout všechny zážitky',
  payWithCreditCard: 'Platit kredit',
  payWithRoomCharge: 'Platit poplatek za pokoj',
  payWithMemberCharge: 'Platit poplatek pro členy',
  payWith: 'Platit s',
  bookBulkErrorByCard:
    'Při potvrzení vaší rezervace došlo k problému. Z vaší karty nebyl poplatek účtován.',
  bookBulkErrorByRoomCharge: 'Neplatné příjmení a číslo pokoje.',
  bookBulkErrorByMemberCharge: 'Neplatné příjmení a členské číslo.',
  reviewCancellation: 'Zkontrolovat zrušení',
  selectAReservationToCancel: 'Vyberte rezervaci k zrušení',
  confirmCancellation: 'Potvrdit zrušení',
  cancellable: 'Zrušitelný',
  cancelled: 'Zrušeno',
  deadlinePassed: 'Termín pro zrušení uplynul',
  noCancellations: 'Zrušení není možné',
  reviewReschedule: 'Vaše rezervace',
  selectAReservationToReschedule: 'Vyberte rezervaci k přeplánování',
  confirmReservation: 'Potvrdit rezervaci',
  confirm: 'Potvrdit',
  selectADateAndTime: 'Vyberte datum a čas',
  noOtherSessionsAvailableForThisExperience:
    'Pro tuto zkušenost nejsou k dispozici žádné další relace.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'Tuto rezervaci již nelze přeplánovat. Pošlete e-mail na {{brandEmail}}',
  thisReservationCannotBeRescheduled: 'Tuto rezervaci nelze přeplánovat',
  noTimesAvailable: 'Žádné dostupné časy',
  noBookingsAvailable: 'Žádné rezervace nejsou k dispozici',
  youPaid: 'Zaplatili jste',
  refund: 'Vráceno',
  yourRefund: 'Vaše vrácení',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'Vrácení bude zpracováno na původní platbu.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'Tuto rezervaci již nelze zrušit. Prosím e-mail {{brandEmail}}',
  reservationCancelled: 'Rezervace zrušena',
  thisReservationCannotBeCancelled: 'tuto rezervaci nelze zrušit',
  thisReservationHasAlreadyBeenCancelled: 'Tato rezervace již byla zrušena',
  theHotel: 'hotel',
  cancelling: 'Zrušení',
  somethingWentWrong: 'Něco se pokazilo',
  previouslyRefunded: 'Dříve vráceno',
  remainingBalance: 'Zbývající zůstatek',
  phoneNumber: 'Telefonní číslo',
  requestToBookConfirmationText: 'Potvrzovací email byl odeslán na {{email}}',
  reservationRescheduled: 'Rezervace přeplánována',
  yourReservationWasRescheduledTo: 'Vaše rezervace byla přeplánována na',
  viewExperiences: 'Zobrazit zážitky',
  joinBook: 'Přihlásit se a rezervovat',
  signInBook: 'Přihlásit se a rezervovat',
  signAndJoin: 'Přihlásit se nebo se přihlásit',
  signAndJoinDescription:
    'World of Hyatt FIND zážitky jsou vyhrazeny pro členy World of Hyatt. Přihlaste se nebo se přihlaste k rezervaci a získatte body. Nemáte zájem se přihlásit? Můžete stále rezervovat nezávazné zážitky odebráním zážitku World of Hyatt z vašeho košíku.',
  promoOrFind: 'Promo nebo FIND kreditní kód',
  hyattTermsAndConditions: 'Smluvní podmínky',
  hyattTermsAndConditionsAgreement:
    'Potvrzením této rezervace souhlasím se storno podmínkami. Přečetl(a) jsem si a beru na vědomí použití svých osobních údajů v souladu s',
  hyattTermsAndConditionsLink: 'Zásadami ochrany osobních údajů Hyatt',
  hyattWaiverText:
    'Zakoupením tohoto zážitku souhlasím, rozumím a beru na vědomí, jak za sebe, tak za jakoukoli osobu, která se účastní zážitku zakoupeného mnou (pokud existuje), následující podmínky',
  hyattWaiverLink: 'obecné zřeknutí se odpovědnosti',
  priceDisclaimer: 'Zahrnuje poplatky před daní',
  curatedRecommendations: 'Vybrané doporučení',
  moreExperiencesYouMightLike: 'Další zážitky, které byste mohli mít zájem',
  similarExperiencesAvailableToBookDirectly:
    'Podobné zážitky dostupné k přímé rezervaci',
  experiencesAvailableAroundYourBookingDate:
    'Zážitky dostupné kolem vašeho data rezervace',
  confirmationEmailSent:
    'Potvrzovací email byl odeslán na {{email}} s dalšími detaily.',
  youreBooked: 'Jste rezervováni',
  purchaserInformation: 'Informace o kupujícím',
  requiredFieldIndicator: '* označuje povinné pole',
  resourceSelectionTitle: 'Vyberte si možnosti',
  resourceSelectionDescription: 'Vyberte možnost pro každou položku rezervace.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'Vyberte {{attributeName}}',
  resourceValueSoldOut: '{{label}} (vyprodáno)',
  resourceValueUnavailableWith: '{{label}} (nedostupné s {{picks}})',
  resourceOptionsUnavailable:
    'Možnosti pro tento čas se nepodařilo načíst. Zkuste to prosím znovu.',
  resourceOptionsRetry: 'Zkusit znovu',
  changeResourceSelections: 'Změnit výběr',
};
